import { renderDate } from '../utility/personTabGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  Prefix: '',
  FirstName: '',
  MiddleName: '',
  LastName: '',
  Suffix: '',
  NickName: '',
  NameType: '',
  Notes: '',
};

export const NAME_GRID_COLUMNS = [
  { field: 'ptsNameID', headerName: 'Name ID', width: 130 },
  { field: 'NameType', headerName: 'Name Type', width: 150 },
  { field: 'FirstName', headerName: 'First Name', width: 160 },
  { field: 'MiddleName', headerName: 'Middle Name', width: 160 },
  { field: 'LastName', headerName: 'Last Name', width: 160 },
  { field: 'NickName', headerName: 'Nick Name', width: 150 },
  { field: 'Prefix', headerName: 'Prefix', width: 130 },
  { field: 'Suffix', headerName: 'Suffix', width: 130 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
